import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate, useParams } from "react-router-dom";
import AuthAction from "../../../stores/actions/authAction";

function BSPanelAccess() {
  const routeParams = useParams();
  const id = routeParams.id;
  const dispatch = useDispatch<any>();
  const navigate = useNavigate();

  const getBSId = useCallback(async () => {
    const result = await dispatch(
      AuthAction.bsPanelAccess({
        id: id,
      })
    );
    window.location.href = "/dashboard";
  }, [dispatch, id]);

  useEffect(() => {
    getBSId();
  }, [getBSId]);

  return (
    <div className="text-center mt-5">
      <Link to="#" onClick={getBSId} className="btn btn-primary btn-sm">
        Test redirect to login
      </Link>
    </div>
  );
}

export default BSPanelAccess;
